import { FamilyTenantFormValues } from "pages/jp/FamilyTrialRegister/type";

export const initialFormValues: FamilyTenantFormValues = {
  user_last_name: "",
  user_first_name: "",
  user_email: "",
  employee_email: "",
  accepted_privacy: "0",
  accepted_terms: "0",
};

// 規約改定後も最新版を参照できるよう、ファイル直リンクでなく格納フォルダへのリンク(Legal提供)
export const FAMILY_PROGRAM_TERMS_URL =
  "https://drive.google.com/drive/folders/1_xiXl0leeMNDxUAAxi0dAFdV_6eeVt_H?usp=sharing";
